import { Combobox } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { guardArray } from "@msuite/utils/array";
import { guardString } from "@msuite/utils/strings";
import type { Control, FieldValues, Path } from "react-hook-form";
import { useMembers } from "@/hooks/use-members";

/** Props Interface */
interface UserPickerProps<T extends FieldValues> {
	control: Control<T>;
	name: Path<T>;
	isNullable?: boolean;
	excludeUserIds?: string[];
}

export function UserPicker<T extends FieldValues>({
	control,
	name,
	isNullable,
	excludeUserIds,
}: UserPickerProps<T>) {
	/** Query */
	const { members } = useMembers();
	const { t } = useTranslation();

	/** Render */
	return (
		<Combobox
			label={t("users.user")}
			isRequired
			placeholder={t("users.select_user")}
			keyExtractor={(item) => item.value}
			displayValue={(item) => guardString(item.label)}
			control={control}
			isNullable={isNullable}
			name={name}
			options={guardArray(members)
				.filter((member) => !excludeUserIds?.includes(member.user.id))
				.map((member) => ({
					label: member.user.name,
					value: member.user.id,
				}))}
		/>
	);
}
